import { render, staticRenderFns } from "./goods-add.vue?vue&type=template&id=40947710&scoped=true&"
import script from "./goods-add.vue?vue&type=script&lang=js&"
export * from "./goods-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40947710",
  null
  
)

export default component.exports